import { useMediaQuery as useMediaQuery_ } from "@react-hookz/web";
import { useWindow } from "~/lib/hooks/window";
import { theme } from "~/lib/media/breakpoints";
import { removeAtMedia } from "~/lib/utils";
const useMediaQuery = (breakpointString, options) => useMediaQuery_(removeAtMedia(breakpointString), options);

/**
 *  Check current screen is fitting the breakpoint string or not
 *  @example useResponsive(theme.breakpoint.up("desktop"))
 */
export const useResponsive = (breakpointString, defaultValue = false, options) => {
  const mediaValue = useMediaQuery(breakpointString, {
    initializeWithValue: false,
    ...options
  });
  return mediaValue !== null && mediaValue !== void 0 ? mediaValue : defaultValue;
};
export const useBreakpoint = () => {
  var _ref;
  const isLargeDesktopUp = useMediaQuery(theme.breakpoints.up("largeDesktop"), {
    initializeWithValue: false
  });
  const isMediumDesktop = useMediaQuery(theme.breakpoints.only("mediumDesktop"), {
    initializeWithValue: false
  });
  const isHomeDesktop = useMediaQuery(theme.breakpoints.only("homeDesktop"), {
    initializeWithValue: false
  });
  const isSmallDesktop = useMediaQuery(theme.breakpoints.between("desktop", "mediumDesktop"), {
    initializeWithValue: false
  });
  const isTablet = useMediaQuery(theme.breakpoints.only("tablet"), {
    initializeWithValue: false
  });
  const isMobile = useMediaQuery(theme.breakpoints.only("mobile"), {
    initializeWithValue: false
  });
  const window = useWindow();
  // When it's under ssr, return mobile
  if (window) return "mobile";
  const map = {
    desktop: isSmallDesktop,
    homeDesktop: isHomeDesktop,
    largeDesktopUp: isLargeDesktopUp,
    mediumDesktop: isMediumDesktop,
    mobile: isMobile,
    tablet: isTablet
  };
  return (_ref = Object.keys(map).find(breakpoint => map[breakpoint])) !== null && _ref !== void 0 ? _ref : "mobile";
};